import React from "react";
import { AnnouncementBarSettingsContent } from "../components/MasterSettings/AnnouncementBarSettings/AnnouncementBarSettingsContent";
import { ToastContainer } from "react-toastify";

export const AnnouncementBarSettings = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AnnouncementBarSettingsContent />
        </div>
      </div>
    </div>
  );
};
